<template>
  <div :id="contract.id" class="list-box-container">
    <template>
      <div class="d-flex list-box-header col-12 pointer" @click.middle.exact="viewMiddle($event, contract.id)" @click.left.exact="view($event, contract.id)">
        <div class="pl-0 list-box-header-left col-lg-7 col-7 col-md-6 pr-3">
          <div class="pl-0 d-flex align-items-center col-5 col-md-6">
            <div class="list-box-status align-items-start col-12">
              <span class="ref-id">
                {{ contract.name }}
              </span>
            </div>
          </div>
          <div class="pl-0 d-flex align-items-center col-7">
            <div class="list-box-status align-items-start col-12">
              <span>
                {{ contract.companies.length > 5 ?
                  companies(contract.companies.slice(0, 5)) +
                  ' and ' + (contract.companies.length - 5) +
                  ' more' :
                  companies(contract.companies)
                }}
              </span>
            </div>
          </div>
        </div>
        <div class="list-box-header-right col-lg-5 col-5 pl-4">
          <div class="d-flex align-items-center col-9">
            {{ contract.created_at }}
          </div>
          <div class="d-flex align-items-center col-3">
            <i class="fa fa-circle pr-2" :class="[contract.active === 1 ? 'active' : 'inactive']" />
            {{ contract.active === 1 ? 'Active' : 'Inactive' }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    contract: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({}),
  methods: {
    companies(companies) {
      return companies
        .map(company => {
          return company.name;
        })
        .join(', ');
    },
    viewMiddle(event, id) {
      const routeData = this.$router.resolve({
        path: `/contracts/edit/${id}`,
        query: { data: this.q },
      });
      window.open(routeData.href, '_blank');
    },
    view(event, id) {
      this.$router.push(`/contracts/edit/${id}${this.q ? `?q=${encodeURIComponent(this.q)}` : ''}`);
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
}
.list-box-status {
  align-items: normal;
}
.list-box-header {
  min-height: 66px;
}
.full-name {
  font-weight: 500;
  font-size: 16px;
  color: #4c5669;
}
.active {
  color: #2db400;
  font-size: 11px;
}
.inactive {
  color: #ff4d4d;
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/contracts/ContractsBlock.vue